'use client';

import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/slw/shared/ui/dialog';
import { Button } from '@/slw/shared/ui/button';
import { AlertTriangle } from 'lucide-react';

interface SessionExpiredDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
  onCancel: () => void;
}

export const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({ 
  isOpen, 
  onClose, 
  onLogin, 
  onCancel 
}) => {
  const handleLogin = () => {
    onClose();
    onLogin();
  };

  const handleCancel = () => {
    onClose();
    onCancel();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <DialogTitle>Session Expired</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            Your session has expired. Please log in again to continue.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-end gap-2">
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleLogin}>
            Login
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
